export function Field({
  id,
  label,
  value,
  editing,
  onChange,
  disabled,
  maxLength,
  required,
  error,
}: {
  id?: string;
  label: string;
  value: string;
  editing: boolean;
  onChange?: (v: string) => void;
  disabled?: boolean;
  maxLength?: number;
  required?: boolean;
  error?: string;
}) {
  const canEdit = editing && !disabled && onChange;
  return (
    <div>
      <label className="mb-1 block text-[11px] font-semibold tracking-wide text-[var(--dash-muted)] uppercase">
        {label}
        {required ? (
          <span className="ml-1 text-red-500" aria-hidden>
            *
          </span>
        ) : null}
      </label>
      {canEdit ? (
        <input
          id={id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          maxLength={maxLength}
          aria-invalid={Boolean(error)}
          placeholder={`Enter ${label}`}
          className={`w-full rounded-xl border bg-[var(--dash-soft)] px-3 py-2.5 text-sm font-semibold text-[var(--dash-ink)] placeholder:font-normal placeholder:text-[var(--dash-muted)]/60 outline-none transition focus:border-[var(--dash-brand)] focus:ring-2 focus:ring-[var(--dash-brand)]/10 ${
            error ? 'border-red-400' : 'border-[var(--dash-line)]'
          }`}
        />
      ) : (
        <p className="m-0 rounded-xl border border-[var(--dash-line)] bg-[var(--dash-soft)]/60 px-3 py-2.5 text-sm font-semibold text-[var(--dash-ink)]">
          {value || '—'}
        </p>
      )}
      {error ? (
        <p className="m-0 mt-1 text-xs font-medium text-red-500" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
